import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'checkout-debit-plus-block',
    templateUrl: './debit-plus-block.component.html',
    styleUrl: 'debit-plus-block.component.scss',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DebitPlusBlockComponent {}
